import { Component, Input } from '@angular/core';
import { Timezone } from '@freelancer/datastore/collections';
import { IconColor, IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';
import { TextAlign } from '@freelancer/ui/text';

@Component({
  selector: 'app-user-profile-summary-extra-info',
  template: `
    <fl-grid *ngIf="timezone && timezone?.offset !== undefined">
      <fl-col
        [col]="1"
        [flMarginBottom]="Margin.XXSMALL"
        [flMarginRight]="Margin.XXSMALL"
      >
        <fl-icon
          [size]="IconSize.MID"
          [color]="IconColor.MID"
          [name]="'ui-clock-v2'"
        ></fl-icon>
      </fl-col>
      <fl-col [col]="9">
        <fl-text [textAlign]="TextAlign.LEFT" i18n="Current user time label">
          It's currently
          {{ time | date: 'h:mm aa':timezone?.offset }} here
        </fl-text>
      </fl-col>
    </fl-grid>

    <fl-grid *ngIf="!userIsAgent && registrationDate">
      <fl-col
        [col]="1"
        [flMarginBottom]="Margin.XXSMALL"
        [flMarginRight]="Margin.XXSMALL"
      >
        <fl-icon
          [size]="IconSize.MID"
          [color]="IconColor.MID"
          [name]="'ui-medal'"
          [flMarginRight]="Margin.XXSMALL"
        ></fl-icon>
      </fl-col>
      <fl-col [col]="9">
        <fl-text [textAlign]="TextAlign.LEFT" i18n="Join date label">
          Joined {{ registrationDate | date: 'MMMM d, y' }}
        </fl-text>
      </fl-col>
    </fl-grid>

    <fl-grid
      *ngIf="!userIsAgent && recommendations !== undefined"
      class="Recommendations"
    >
      <fl-col [col]="1" [flMarginRight]="Margin.XXSMALL">
        <fl-icon
          [size]="IconSize.MID"
          [color]="IconColor.MID"
          [name]="'ui-thumbs-up-v2'"
          [flMarginRight]="Margin.XXSMALL"
          [flMarginBottom]="Margin.XXXSMALL"
        ></fl-icon>
      </fl-col>
      <fl-col [col]="9" class="RecommendationsText">
        <fl-text [textAlign]="TextAlign.LEFT">
          {{ recommendations }}

          <ng-container
            *ngIf="recommendations === 1; else pluralRecommendations"
            i18n="Singular recommendation label"
          >
            Recommendation
          </ng-container>

          <ng-template #pluralRecommendations>
            <ng-container i18n="Plural recommendation label">
              Recommendations
            </ng-container>
          </ng-template>
        </fl-text>
      </fl-col>
    </fl-grid>
  `,
  styleUrls: ['./user-profile-summary-extra-info.component.scss'],
})
export class UserProfileSummaryExtraInfoComponent {
  IconSize = IconSize;
  IconColor = IconColor;
  Margin = Margin;
  TextAlign = TextAlign;

  @Input() registrationDate?: number;
  @Input() recommendations?: number;
  @Input() timezone?: Timezone;
  @Input() userIsAgent: boolean;
  @Input() isLoggedIn: boolean;
  time: number = Date.now();
}
